export default angular.module('contartemx.preferencias.certificados', [
  'contartemx',
  'ui.router',
  'ngTable',
  'ui.bootstrap',
  'datePicker',
  'tableTools',
  'fileUpload',
  'loader'
]).controller('CertificadosCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  'NgTableParams',
  '$filter',
  '$http',
  '$uibModal',
  'fileUploadService',
  'callToWebService',  
  function ($scope, $state, $stateParams, NgTableParams, $filter, $http, $uibModal, fileUploadService, callToWebService) {
    $scope.ResultsCBB = true;
    $scope.ResultsCFDI = true;
    $scope.llamadoInicial = 0;
    $scope.ResultsCbb = false;
    $scope.ResultsCfdi = false;
    $scope.noMoreCbb = true;
    $scope.noMoreCfdi = true;
    $scope.loading = true;
    function ListCookies() {
      var theCookies = document.cookie.split(';');
      var cookiesLista = [];
      for (var i = 1; i <= theCookies.length; i++) {
        cookiesLista.push(theCookies[i - 1]);
      }
      return cookiesLista;
    }
    $scope.tieneCertificados = true;
    $scope.$watch('llamadoInicial', function () {
      $scope.loading = true;
      callToWebService.postCall('ObtenerPantallaCertificados', {}, function succes(data) {
          if (!data.EsError) {
              $scope.cbbActivos = data.Respuesta.ListadoCbbActivos;
              $scope.cbbInactivos = data.Respuesta.ListadoCbbInactivos;
              $scope.cfdiActivos = data.Respuesta.ListadoCfdiActivos;
              $scope.cfdiInactivos = data.Respuesta.ListadoCfdiInactivos;
              $scope.tiposDeIngreso = data.Respuesta.TiposDeIngreso;
              $scope.tieneCertificados = data.Respuesta.TieneCertificados;
              $scope.listaRegimenFiscal = data.Respuesta.ListaRegimenFiscal;
              if ($scope.estadoCertificado) {
                  var orderedDataCbbs = $scope.tableParamsCbb.sorting ? $filter('orderBy')($scope.cbbInactivos, $scope.tableParamsCbb.orderBy()) : $scope.cbbInactivos;
                  $scope.cbbs = orderedDataCbbs.slice(($scope.tableParamsCbb.page() - 1) * $scope.tableParamsCbb.count(), $scope.tableParamsCbb.page() * $scope.tableParamsCbb.count());
                  var orderedDataCfdis = $scope.tableParamsCfdi.sorting ? $filter('orderBy')($scope.cfdiInactivos, $scope.tableParamsCfdi.orderBy()) : $scope.cfdiInactivos;
                  $scope.cfdis = orderedDataCfdis.slice(($scope.tableParamsCfdi.page() - 1) * $scope.tableParamsCfdi.count(), $scope.tableParamsCfdi.page() * $scope.tableParamsCfdi.count());
                  $scope.noMoreCbb = $scope.cbbInactivos.length < $scope.tableParamsCbb.count() ? true : false;
                  $scope.noMoreCfdi = $scope.cfdiInactivos.length < $scope.tableParamsCfdi.count() ? true : false;
              } else {
                  var orderedDataCbbs = $scope.tableParamsCbb.sorting ? $filter('orderBy')($scope.cbbActivos, $scope.tableParamsCbb.orderBy()) : $scope.cbbActivos;
                  $scope.cbbs = orderedDataCbbs.slice(($scope.tableParamsCbb.page() - 1) * $scope.tableParamsCbb.count(), $scope.tableParamsCbb.page() * $scope.tableParamsCbb.count());
                  var orderedDataCfdis = $scope.tableParamsCfdi.sorting ? $filter('orderBy')($scope.cfdiActivos, $scope.tableParamsCfdi.orderBy()) : $scope.cfdiActivos;
                  $scope.cfdis = orderedDataCfdis.slice(($scope.tableParamsCfdi.page() - 1) * $scope.tableParamsCfdi.count(), $scope.tableParamsCfdi.page() * $scope.tableParamsCfdi.count());
                  $scope.noMoreCbb = $scope.cbbActivos.length < $scope.tableParamsCbb.count() ? true : false;
                  $scope.noMoreCfdi = $scope.cfdiActivos.length < $scope.tableParamsCfdi.count() ? true : false;
              }
              $scope.ResultsCbb = $scope.cbbs.length > 0 ? true : false;
              $scope.ResultsCfdi = $scope.cfdis.length > 0 ? true : false;
          } else {
              $scope.showMsg(data.Mensaje, 'error');
          }
          $scope.loading = false;
      }, function error(data) {
          if (data.Mensaje) {
              $scope.showMsg(data.Mensaje, 'error');
          } else {
              $scope.showMsg('Ocurrio un error al intentar cargar la pantalla', 'error');
          }
      });
    }, true);
    $scope.TimbresUtilizados = 100;
    $scope.TimbresUtilizables = 500;
    $scope.PorcentajeTimbres = $scope.TimbresUtilizados / $scope.TimbresUtilizables * 100;
    $scope.select = function (index, certificado) {
      $scope.cbbSeleccionado = certificado.ClaveCertificado;
      $scope.selectedRow = index;
    };
    $scope.deselect = function () {
      $scope.selectedRow = -1;
      $scope.selectedRowCfdi = -1;
    };
    $scope.selectCfdi = function (index, certificado) {
      $scope.cfdiSeleccionado = certificado.ClaveCertificado;
      $scope.selectedRowCfdi = index;
      $scope.estaActivoCfdi = certificado.EstaActivo;
    };
    $scope.deselectCfdi = function () {
      $scope.selectedRow = -1;
      $scope.selectedRowCfdi = -1;
    };
    $scope.deselectCfdisTable = function () {
      var theads = document.getElementsByTagName('thead');
      theads[1].style.display = '';
      var actions = $('.actions2')[0];
      if (typeof actions !== 'undefined') {
        actions.style.display = 'none';
      }
      $scope.selectedRowCfdi = -1;
    };
    $scope.hideActionsCfdi = function () {
      var theads = document.getElementsByTagName('thead');
      theads[1].style.display = 'none';
      var actions = $('.actions2')[0];
      if (typeof actions !== 'undefined') {
        actions.style.display = 'none';
      }
    };
    $scope.deselectCbbsTable = function () {
      var theads = document.getElementsByTagName('thead');
      theads[0].style.display = '';
      var actions = $('.actions1')[0];
      if (typeof actions !== 'undefined') {
        actions.style.display = 'none';
      }
      $scope.selectedRow = -1;
    };
    $scope.selectedOpt = 0;
    $scope.selectMenuOpt = function (i) {
      $scope.selectedOpt = i;
      $scope.llamadoInicial = $scope.llamadoInicial + 1;
    };
    $scope.estadoCertificado = '';
    $scope.editarVerOpc = 'Editar';
    $scope.editarVerIcono = 'icon--circleEdit';
    $scope.seleccionarEstadoCertificado = function (i) {
      switch (i) {
      case 0:
        $scope.estadoCertificado = '';
        $scope.editarVerOpc = 'Editar';
        $scope.editarVerIcono = 'icon-Circle_Edit';
        $scope.llamadoInicial = $scope.llamadoInicial + 1;
        break;
      case 1:
        $scope.estadoCertificado = 'Inactivos';
        $scope.editarVerOpc = 'Ver';
        $scope.editarVerIcono = 'icon--circleAccess';
        $scope.llamadoInicial = $scope.llamadoInicial + 1;
        break;
      }
      $scope.ResultsCbb = $scope.cbbs.length > 0 ? true : false;
      $scope.ResultsCfdi = $scope.cfdis.length > 0 ? true : false;
    };
    $scope.tableParamsCbb = new NgTableParams({
      page: 1,
      total: 1,
      count: 15,
      counts: [],
      sorting: { Expira: 'asc' }
    });
    $scope.tableParamsCfdi = new NgTableParams({
      page: 1,
      total: 1,
      count: 15,
      counts: [],
      sorting: { Expira: 'asc' }
    });
    $scope.$watch('tableParamsCbb', function (params, paramsOld) {
      if ($scope.cbbs) {
        if ($scope.estadoCertificado) {
          var orderedDataCbbs = $scope.tableParamsCbb.sorting ? $filter('orderBy')($scope.cbbInactivos, $scope.tableParamsCbb.orderBy()) : $scope.cbbInactivos;
          $scope.cbbs = orderedDataCbbs.slice(($scope.tableParamsCbb.page() - 1) * $scope.tableParamsCbb.count(), $scope.tableParamsCbb.page() * $scope.tableParamsCbb.count());
        } else {
          var orderedDataCbbs = $scope.tableParamsCbb.sorting ? $filter('orderBy')($scope.cbbActivos, $scope.tableParamsCbb.orderBy()) : $scope.cbbActivos;
          $scope.cbbs = orderedDataCbbs.slice(($scope.tableParamsCbb.page() - 1) * $scope.tableParamsCbb.count(), $scope.tableParamsCbb.page() * $scope.tableParamsCbb.count());
        }
      }
    }, true);
    $scope.$watch('tableParamsCfdi', function (params, paramsOld) {
      if ($scope.cfdis) {
        if ($scope.estadoCertificado) {
          var orderedDataCfdis = $scope.tableParamsCfdi.sorting ? $filter('orderBy')($scope.cfdiInactivos, $scope.tableParamsCfdi.orderBy()) : $scope.cfdiInactivos;
          $scope.cfdis = orderedDataCfdis.slice(($scope.tableParamsCfdi.page() - 1) * $scope.tableParamsCfdi.count(), $scope.tableParamsCfdi.page() * $scope.tableParamsCfdi.count());
        } else {
          var orderedDataCfdis = $scope.tableParamsCfdi.sorting ? $filter('orderBy')($scope.cfdiActivos, $scope.tableParamsCfdi.orderBy()) : $scope.cfdiActivos;
          $scope.cfdis = orderedDataCfdis.slice(($scope.tableParamsCfdi.page() - 1) * $scope.tableParamsCfdi.count(), $scope.tableParamsCfdi.page() * $scope.tableParamsCfdi.count());
        }
      }
    }, true);
    $scope.showMoreCbb = function () {
      //$scope.tableParamsCbb.count += 15;
      if ($scope.estadoCertificado) {
        $scope.noMoreCbb = $scope.cbbInactivos.length < $scope.tableParamsCbb.count() ? true : false;
      } else {
        $scope.noMoreCbb = $scope.cbbActivos.length < $scope.tableParamsCbb.count() ? true : false;
      }
    };

    $scope.showMoreCfdi = () => {
      $scope.tableParamsCfdi.count($scope.tableParamsCfdi.count() + 15);

      if ($scope.estadoCertificado) {
        $scope.noMoreCfdi = $scope.cfdiInactivos.length < $scope.tableParamsCfdi.count() ? true : false;
      } else {
        $scope.noMoreCfdi = $scope.cfdiActivos.length < $scope.tableParamsCfdi.count() ? true : false;
      }
    };

    $scope.agregarCertificado = () => {
      $scope.$emit('nextOnboardingStep', 'preferencias.modal.nuevoCertificado');
      $state.go('preferencias.certificados.crear-editar', { crearEditar: 'Crear', cveCertificado: null });
    };

    $scope.desactivarCertificado = function (cve, rowIndex, tipoCertificado) {
      if (tipoCertificado == 'cfdi') {
        callToWebService.postCall('DesactivarCertificado', { cveCertificado: cve },
          function sucess(data) {
              $scope.cfdis.splice(rowIndex, 1);            
          },
          function error(data) {
            mostrarNotificacion.error(data.Mensaje);
          });
      } else {
        callToWebService.postCall('DesactivarFirmaElectronica', { cveCertificado: cve },
          function sucess(data) {    
              $scope.cfdis.splice(rowIndex, 1);            
          },
          function error(data) {
            mostrarNotificacion.error(data.Mensaje);
          });
      }
    };

    $scope.headerAction = function (index, certificado, rowIndex) {
      if (certificado) {
        var cveCertificado = certificado.ClaveCertificado;
        switch (index) {
        case 0:
          $scope.rowIndexCbb = rowIndex;
          $scope.displayPopupCertificados(false, 'cbb');
          break;
        case 1:
          var selRow = $('table.certificadosCbb tr.selected');
          var cancelPop = selRow.find('.acciones a.cancel');
          $('.cancelar-certificados-popover[ClaveCertificado=\'' + cveCertificado + '\']').removeClass('hidden');
          cancelPop.trigger('pop-it-over');
          $('#contextmenu').removeClass('open');
          break;
        default:
          return;
        }
      }
    };
    $scope.headerActionCfdi = function (index, certificado, rowIndex) {
        if (certificado) {
            var cveCertificado = certificado.ClaveCertificado;
            switch (index) {
                case 0:
                    $scope.rowIndexCfdi = rowIndex;
                    //$scope.displayPopupCertificados(false, 'cfdi');
                    $state.go("preferencias.certificados.crear-editar", { crearEditar: 'Editar', cveCertificado });
                    break;
                case 1:
                    var selRow = $('table.certificadosCfdi tr.selected');
                    var cancelPop = selRow.find('.acciones a.cancel');
                    $(".popover--cancelCFDI").addClass("popover--hidden");
                    $('.popover--cancelCFDI[ClaveCertificado=\'' + cveCertificado + '\']').removeClass('hidden');
                    $('.popover--cancelCFDI[ClaveCertificado=\'' + cveCertificado + '\']').removeClass('popover--hidden');
                    $('#contextmenu').removeClass('open');
                    break;
                default:
                    return;
            }
        }
    };
    $scope.hideCancelPops = function () {
      $('.popoverCancel-popover').addClass('hidden');
    };
    $scope.alert = [];
    $scope.showMsg = function (mensaje, tipo) {
      $scope.alert = [];
      $scope.alert.push({
        type: tipo,
        msg: mensaje
      });
    };
    $scope.closeAlert = function () {
      $scope.alert = [];
    };
    $scope.displayPopupCertificados = function (esNuevoCertificado, tipoDeCertificado) {             

        $scope.loading = true;

      var modalInstance = $uibModal.open({
          template: require('../../../../../app/views/Preferencias/Certificados/Certificado_modal.html'),
          controller: 'CertificadoNuevoCtrl',
          windowClass: 'certificados-modal modal--big',
          appendTo: angular.element(document.querySelector('.modal-parent')), 
          resolve: {
            ingresos: function () {
              return $scope.tiposDeIngreso;
            },
            certificado: function () {
              if (esNuevoCertificado) {
                return null;
              } else {
                if (tipoDeCertificado == 'cbb') {
                  return $scope.cbbSeleccionado;
                }
                if (tipoDeCertificado == 'cfdi') {
                  return $scope.cfdiSeleccionado;
                }
              }
            },
            listaRegimenFiscal: function () {
                return $scope.listaRegimenFiscal;
            },
            estaActivo: function () {
                return $scope.estaActivoCfdi;
            },
          }
      });

      modalInstance.opened.then(function () {
          $scope.$emit('nextOnboardingStep', 'preferencias.modal.nuevoCertificado');
      });
               
      modalInstance.result.then(function (data) {
        $scope.llamadoInicial = $scope.llamadoInicial + 1;
        $scope.showMsg(data.Mensaje, 'info');

        if (data.CodigoRespuesta == 200 && !data.EsError) {
            $scope.$emit('nextOnboardingStep');
        } else {
            $scope.$emit('nextOnboardingStep', 'preferencias.boton.nuevoCertificado');
        }

      }, function () {
          $scope.$emit('nextOnboardingStep');
      }).finally(function () {
          $scope.loading = false;
      });

    };
    
  }
]).controller('CertificadoNuevoCtrl', ($scope, $state, $stateParams, $http, $filter, apiCall, callToWebService, ObtenerUltimosAnios) => {

  let certificado = $stateParams.cveCertificado;

  $scope.uploadFormData = {

        fueUsado: false,
        ultimoFolio: 0,
        serie: '',
        folioInicial: 1,
        folioInicialCP: 1,
        ultimoFolioCP: 0,
        folioInicialNC: 1,
        ultimoFolioNC: 0,
        anoAprobacion: new Date().getFullYear()
    };
    $scope.esNuevoCertificado = true;
    $scope.esNuevoCertificado = !$stateParams.cveCertificado;
    $scope.loading = false;
    //$scope.listaRegimenFiscal = listaRegimenFiscal;
    $scope.estaActivo = $scope.estaActivoCfdi;
  $scope.formSuccessCB = function (data) {
    $scope.loading = false;
    if (data.CodigoRespuesta == 200 && !data.EsError) {
      $scope.$emit('nextOnboardingStep');
      $state.go('preferencias.certificados', {}, {reload: true});
        } else {
            if ($scope.certificadoCfdi) {
                $scope.alerts = [];
              $scope.alerts.push({
                    type: 'error',
                    msg: data.Mensaje
                });
            } else {
              $scope.alerts = [];
              $scope.alerts.push({
                    type: 'error',
                    msg: data.Mensaje
                });
            }
      }
    };
  $scope.formErrorCB = function (data) {
    $scope.loading = false;
    console.log(data)
        if (data && data.error) {
            if (data.error === 501) {
                $scope.validarCertificado(data.form);
            } else {
                if ($scope.certificadoCfdi) {
                    $scope.alerts = [];
                    $scope.alerts.push({
                        type: 'error',
                        msg: 'Debes agregar ambos archivos, Certificado (.cer) y Llave Privada (.key)'
                    });
                }
            }
      }
  };

  $scope.switchWindow = tipo => $scope.certificadoCfdi = tipo == 'cfdi';

    $scope.llamadoDatosCertificado = 1;
    $scope.certificadoModal = [];
    $scope.$watch('llamadoDatosCertificado', function () {
        if (certificado) {
          $scope.esNuevoCertificado = false;
          $scope.loading = true;

            callToWebService.postCall('ObtenerDetallesCertificado', { cveCertificado: certificado },
              function sucess(data) {
                $scope.loading = false;

                if (data && data.Respuesta && data.CodigoRespuesta == 200 && data.Respuesta.TipoCertificado == 2) {
                  $scope.certificadoModal = data.Respuesta;
                  if ($scope.certificadoModal.TipoCertificado == 2) {
                    $scope.certificadoCfdi = true;
                    $scope.certificadoFile = data.Respuesta.Certificado;
                    $scope.certificadoKey = data.Respuesta.Llave;
                    $scope.cbbFile = data.Respuesta.CBB;
                  } else {
                    $scope.certificadoCfdi = false;
                    $scope.certificadoFile = data.Respuesta.Certificado;
                    $scope.certificadoKey = data.Respuesta.Llave;
                    $scope.uploadFormData.llavePrivada = data.Respuesta.Clave;
                  }

                  $scope.tipoComprobanteMostrar = data.Respuesta.TipoComprobante;
                  $scope.uploadFormData.serie = data.Respuesta.Serie;
                  $scope.uploadFormData.anoAprobacion = data.Respuesta.Aprobacion;
                  $scope.uploadFormData.regimen = data.Respuesta.RegimenFiscal;
                  $scope.fechaInicial = getDateFromWcf(data.Respuesta.FechaInicial);
                  $scope.fechaFinal = getDateFromWcf(data.Respuesta.FechaFinal);
                  $scope.uploadFormData.ultimoFolio = data.Respuesta.UltimoFolio;
                  $scope.uploadFormData.folioInicial = data.Respuesta.FolioFinal;
                  $scope.uploadFormData.folioInicial = data.Respuesta.FolioInicial;
                  $scope.uploadFormData.folioFinal = data.Respuesta.FolioFinal;
                  $scope.ultimoFolioinput = true;
                  // Complementos de pago
                  $scope.uploadFormData.ultimoFolioCP = data.Respuesta.UltimoFolioCP;
                  $scope.uploadFormData.folioInicialCP = data.Respuesta.FolioInicialCP;
                  $scope.ultimoFolioCPinput = true;
                  // Notas de cr�dito
                  $scope.uploadFormData.ultimoFolioNC = data.Respuesta.UltimoFolioNC;
                  $scope.uploadFormData.folioInicialNC = data.Respuesta.FolioInicialNC;
                  $scope.ultimoFolioNCinput = true;

                  $scope.certificadoActivo = data.Respuesta.EstaActivo;
                } else {
                  $state.go("preferencias.certificados");
                }

                    },
                    function error(data) {
                      $scope.loading = false;
                      $state.go("preferencias.certificados");
                    });
        }
    }, true);
    $scope.desactivarCertificadoModal = function () {
        callToWebService.postCall('DesactivarCertificado', { cveCertificado: certificado },
          function sucess(data) {
            $state.go('preferencias.certificados');
          },
          function error(data) {
              mostrarNotificacion.error(data.Mensaje);
          });
    };

    $scope.actualizarCertificado = function () {
        apiCall.post('ActualizarCertificado', { certificado: certificado, regimen: $scope.uploadFormData.regimen })
            .then(function (data) {
                // Success
              $state.go('preferencias.certificados');
        },
        function (data) {
            // Error
            mostrarNotificacion.error(data.Mensaje);
        }
        );
    };

    $scope.alerts = [];
    function getDateFromWcf(fechaWcf) {
        var d = fechaWcf.match(/(\d+)/)[1];
        var fechaInt = parseInt(d);
        var dateFilter = $filter('date');
        return dateFilter(new Date(fechaInt), 'dd/MM/yy');
    }
    function getTimeForWCF(dateVar) {
        var dateObj = moment(dateVar, 'DD-MM-YY');
        dateObj = dateObj._d;
        var dateUTC = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes(), dateObj.getSeconds(), dateObj.getMilliseconds()));
        return '/Date(' + dateUTC.getTime() + ')/';
    }
  $scope.certificadoCfdi = true;

  $scope.anosDeAprobacion = ObtenerUltimosAnios.porRango(10).map(v => ({ ano: v }));

    $scope.closeModalAlert = function (i) {
        $scope.alert.splice(i, 1);
    };
    $scope.closeClienteModal = () => {
      $scope.$emit('nextOnboardingStep');
        $state.go('preferencias.certificados');
    };
    $scope.uploadFormData.ultimoFolio = 0;
    $scope.$watch('uploadFormData.fueUsado', function () {
        if ($scope.uploadFormData.fueUsado) {
            $scope.ultimoFolioinput = true;
            $scope.uploadFormData.ultimoFolio = null;
        } else {
            $scope.ultimoFolioinput = false;
            $scope.uploadFormData.ultimoFolio = 0;
        }
    }, true);
    $scope.validarCertificado = function (forma) {
        $scope.emptyFields = [];
      $scope.wrongFields = [];
        if (forma && forma.$invalid) {
            if ($scope.certificadoCfdi) {
                if (forma.tipoComprobante && forma.tipoComprobante.$invalid) {
                    if ($scope.checkIfWrong(forma.tipoComprobante)) {
                        $scope.wrongFields.push('Tipo de Comprobante');
                    } else {
                        $scope.emptyFields.push('Tipo de Comprobante');
                    }
                }
                if (forma.serieCfdi.$invalid) {
                    if ($scope.checkIfWrong(forma.serieCfdi)) {
                        $scope.wrongFields.push('Serie');
                    } else {
                        $scope.emptyFields.push('Serie');
                    }
                }
                if (forma.anoAprobacionCfdi.$invalid) {
                    if ($scope.checkIfWrong(forma.anoAprobacionCfdi)) {
                        $scope.wrongFields.push('A\xf1o de Aprobacion');
                    } else {
                        $scope.emptyFields.push('A\xf1o de Aprobacion');
                    }
                }
                if (forma.regimenCfdi.$invalid) {
                    if ($scope.checkIfWrong(forma.regimenCfdi)) {
                        $scope.wrongFields.push('Regimen');
                    } else {
                        $scope.emptyFields.push('Regimen');
                    }
                }

                if (forma.claveLlave.$invalid) {
                    if ($scope.checkIfWrong(forma.claveLlave)) {
                        $scope.wrongFields.push('Clave de la Llave');
                    } else {
                        $scope.emptyFields.push('Clave de la Llave');
                    }
                }
                if (forma.folioInicial.$invalid) {
                    if ($scope.checkIfWrong(forma.folioInicial)) {
                        $scope.wrongFields.push('Folio Inicial');
                    } else {
                        $scope.emptyFields.push('Folio Inicial');
                    }
                }
                if (forma.ultimoFolio.$invalid) {
                    if ($scope.checkIfWrong(forma.ultimoFolio)) {
                        $scope.wrongFields.push('Ultimo Folio Utilizado');
                    } else {
                        $scope.emptyFields.push('Ultimo Folio Utilizado');
                    }
                }
            }
            $scope.displayErrorMessage();
        }
    };
    $scope.checkIfWrong = function (elemObj) {
        if (elemObj.$pristine) {
            return false;
        } else if (elemObj.$dirty && elemObj.$invalid) {
            return true;
        }
    };
    $scope.displayErrorMessage = function () {
        var testfile = $scope.uploadFormData.ultimoFolio;
        if ($scope.emptyFields.length > 0) {
            $scope.msgError = 'Algunos campos requeridos estan vacios, como: ' + $scope.emptyFields[0];
            if ($scope.emptyFields.length > 1) {
                for (var i = 1; i < $scope.emptyFields.length; i++) {
                    $scope.msgError += ', ' + $scope.emptyFields[i];
                }
            }
            if ($scope.wrongFields.length > 0) {
                $scope.msgError += ' y algunos campos no son validos, como: ' + $scope.wrongFields[0];
                if ($scope.wrongFields.length > 1) {
                    for (var i = 1; i < $scope.wrongFields.length; i++) {
                        $scope.msgError += ', ' + $scope.wrongFields[i];
                    }
                }
            }
            if ($scope.certificadoCfdi) {
                $scope.alerts = [];
                $scope.alerts.push({
                    type: 'error',
                    msg: $scope.msgError
                });
            }
        } else if ($scope.wrongFields.length > 0) {
            $scope.msgError = 'Algunos campos no son validos, como: ' + $scope.wrongFields[0];
            if ($scope.wrongFields.length > 1) {
                for (var i = 1; i < $scope.wrongFields.length; i++) {
                    $scope.msgError += ', ' + $scope.wrongFields[i];
                }
            }
            if ($scope.certificadoCfdi) {
                $scope.alerts = [];
                $scope.alerts.push({
                    type: 'error',
                    msg: $scope.msgError
                });
            }
        } else {
        }
    };
    $scope.closeModalAlert = function () {
        $scope.alerts = [];
        $scope.alertsCBB = [];
    };
});
